.root {
	width: var(--checkbox-size);
	height: var(--checkbox-size);
	margin: 0;
	border: var(--checkbox-border-width) solid var(--checkbox-border-color);
	border-radius: var(--border-radius-small);

	/* reset the <span> defaults Base UI renders */
	display: inline-block;
	box-sizing: border-box;
	position: relative; /* anchor for the ::after checkmark */
	vertical-align: text-bottom;
	cursor: pointer;
	outline: none;

	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.root:hover:not(:disabled):not([data-disabled]) {
	border-color: var(--color-primary-hover);
}

.root:focus-visible {
	border-color: var(--color-primary);
	box-shadow: 0 0 0 3px var(--color-primary-focus-ring);
}

.root:disabled,
.root[data-disabled] {
	opacity: 0.5;
	cursor: not-allowed;
}

.indicator {
	display: block;
	width: 100%;
	height: 100%;
	position: relative;
}

.indicator::after {
	content: "";
	position: absolute;
	top: 2px;
	left: 5px;
	width: 5px;
	height: 8px;
	border: solid var(--checkbox-tick-color);
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
	opacity: 0;
	transition: opacity 0.15s ease-in-out;
}

.indicator[data-checked]::after {
	opacity: 1;
}

/*
  Indeterminate state (defined in the Base UI primitive api, but no corresponding bootstrap style)
*/
.indicator[data-indeterminate]::after {
	opacity: 1;
	top: 6px;
	left: 2px;
	width: 10px;
	height: 0;
	border: none;
	border-top: 2px solid var(--checkbox-tick-color);
	transform: none;
}

/* Wrapper + label text when children are passed */
.wrapper {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;
}

.text {
	user-select: none;
	line-height: 15px;
}
